<template>
    <div class="modal fade" id="newsletterSignUp" tabindex="-1" aria-labelledby="newsletterSignUpLabel" aria-hidden="true">
        <div class="modal-dialog">
            <div class="modal-content">
                <div class="modal-header">
                    <h1 class="modal-title fs-5" id="newsletterSignUpLabel">
                        Hírlevél feliratkozás
                    </h1>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" :disabled="loading"></button>
                </div>
                <div class="modal-body">
                    <form :action="url" method="POST" id="newsletterSignUpForm" v-on:submit="submit()">

                        <div class="mb-3">
                            <label for="newsletter_sign_up_first_name">
                                Vezetéknév:
                            </label>

                            <input type="text" class="form-control"
                                   name="FNAME"
                                   id="newsletter_sign_up_first_name"
                                   :readonly="loading"
                                   required>
                        </div>

                        <div class="mb-3">
                            <label for="newsletter_sign_up_last_name">
                                Keresztnév:
                            </label>

                            <input type="text" class="form-control"
                                   name="LNAME"
                                   id="newsletter_sign_up_last_name"
                                   :readonly="loading"
                                   required>
                        </div>

                        <div class="mb-3">
                            <label for="newsletter_sign_up_email">
                                Email cím:
                            </label>

                            <input type="email" class="form-control"
                                   name="EMAIL"
                                   id="newsletter_sign_up_email"
                                   maxlength="255"
                                   :readonly="loading"
                                   required>
                        </div>

                    </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-bs-dismiss="modal" :disabled="loading">
                        Mégse
                    </button>
                    <button type="submit" class="btn btn-primary" form="newsletterSignUpForm">
                        Feliratkozom
                    </button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

import * as Ladda from 'ladda';
import {Modal} from 'bootstrap';

export default {
    props: {
        url: {
            required: true,
            type: String,
        },
    },
    data() {
        return {
            modal: null,
            loading: false,
            submitButton: null,
        }
    },
    mounted() {
        this.submitButton = Ladda.create(this.$el.querySelector('button[type="submit"]'));
        this.modal = new Modal(this.$el);

        this.$el.addEventListener('hidden.bs.modal', () => {
            this.$root.showNewsletterSignUpModal = false;
        });

        this.modal.show();
    },
    methods: {

        submit() {
            this.loading = true;
        },

    },
    watch: {
        loading(value) {
            if (value) {
                this.submitButton.start();
            } else {
                this.submitButton.stop();
            }
        },
    },
}
</script>

<style scoped>

</style>
